"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PaymentPage = void 0;
const react_1 = __importDefault(require("react"));
const react_2 = require("react");
class PaymentPage extends react_2.Component {
    constructor(props) {
        super(props);
        this.render = () => {
            return react_1.default.createElement("div", null, "this is the payment page!");
        };
    }
}
exports.PaymentPage = PaymentPage;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiUGF5bWVudFBhZ2UuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi9zcmMvUGF5bWVudFBhZ2UudHN4Il0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7Ozs7OztBQUFBLGtEQUEwQjtBQUMxQixpQ0FBa0M7QUFFbEMsTUFBYSxXQUFZLFNBQVEsaUJBQWlCO0lBQzlDLFlBQVksS0FBUztRQUNqQixLQUFLLENBQUMsS0FBSyxDQUFDLENBQUE7UUFHaEIsV0FBTSxHQUFHLEdBQWdCLEVBQUU7WUFDdkIsT0FBTyx1RUFBb0MsQ0FBQTtRQUMvQyxDQUFDLENBQUE7SUFKRCxDQUFDO0NBS0o7QUFSRCxrQ0FRQyJ9